import { CardStatusEnum, Query } from '@varo/graphql-schema-types';
import FetchCards from 'services/graphql/queries/FetchCards';
import { AnyVariables, RequestPolicy, useQuery } from 'urql';

interface UseFetchCardsOptions {
  statuses?: CardStatusEnum[];
  allowDuplicatePANs?: boolean;
  requestPolicy?: RequestPolicy;
}

export const useFetchCards = ({
  statuses = [
    CardStatusEnum.New,
    CardStatusEnum.Activated,
    CardStatusEnum.Locked,
    CardStatusEnum.NotActivated,
    CardStatusEnum.Suspended,
  ],
  allowDuplicatePANs = false,
  requestPolicy = 'cache-and-network',
}: UseFetchCardsOptions = {}) => {
  const [{ data, fetching, error }] = useQuery<Query, AnyVariables>({
    query: FetchCards,
    variables: {
      filter: {
        status: statuses,
        allowDuplicatePANs,
      },
    },
    requestPolicy,
  });

  return {
    data,
    fetching,
    error,
  };
};
